import React, { useMemo } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import navItems, { clientRoutes } from 'src/_nav'

const FALLBACK_REDIRECT = '/device-reading'

const collectSidebarPaths = (items) => {
  const paths = new Set()
  const walk = (list) => {
    if (!Array.isArray(list)) return
    list.forEach((item) => {
      if (item?.to) paths.add(item.to)
      if (item?.items) walk(item.items)
    })
  }
  walk(items)
  return paths
}

export const getUserZone = () => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      const decoded = jwtDecode(token)
      if (decoded?.zone) return decoded.zone
    }
  } catch (_) {
    // fall through to localStorage
  }
  return localStorage.getItem('user_zone') || undefined
}

const isClientRoute = (pathname) =>
  (clientRoutes || []).some((r) =>
    r instanceof RegExp ? r.test(pathname) : r === pathname,
  )

const ZoneGuard = () => {
  const { pathname } = useLocation()
  const sidebarPaths = useMemo(() => collectSidebarPaths(navItems), [])

  if (sidebarPaths.has(pathname)) return <Outlet />

  if (isClientRoute(pathname)) return <Outlet />

  if (getUserZone() === '_ALL') return <Outlet />

  return <Navigate to={FALLBACK_REDIRECT} replace />
}

export default ZoneGuard
